import {makeAutoObservable} from "mobx";
import {getDayPath, getDefaultContentUrl} from "./ContentStore";
import {displayErrorDialogPrompt} from "../common/util/errror/log.util";
import {langTypes} from "../common/enums/ExcelEnum";

const logPrefix  = "[OddStepFiveStore]"
export default class OddStepFiveStore {

    constructor(props) {
        this.contentRepository = props.contentRepository;
        this.contentStore = props.contentStore;
        this.dialogStore = props.dialogStore;
        this.commonStore = props.commonStore;

        this.contentList = [];
        this.originalContentList = [];
        this.contentTapIndex = 0;
        this.isProcessing = false;
        this.selectFirstIndex = 0;
        this.mouseDownElId = undefined;
        this.updateContent = null;
        this.popoverState = false;

        makeAutoObservable(this);
    }

    openErrorDialog = (info) => {
        if (this?.dialogStore) {
            this.dialogStore.openErrorDialog(info)
        }
    };

    setContentTapIndex = (index) => {
        this.contentTapIndex = index;
    };

    getSelectedContent = () => {
        return this.contentList.find(content => content.languageCode === this.getSelectedLangCode());
    }

    getSelectedLangCode = () => {
        return langTypes[this.contentTapIndex];
    }

    getContent = (tabIndex) => {
        const languageCode = langTypes[tabIndex];
        return this.contentList.find((c) => c.languageCode === languageCode);
    }

    setIsProcessing = (isProcessing) => {
        this.isProcessing = isProcessing;
    }

    setSelectFirstIndex = (index) => {
        this.selectFirstIndex = index;
    }

    setMouseDownElId = (id) => {
        this.mouseDownElId = id;
    }

    addSentence = (sentenceList, newStartIndex, newEndIndex) => {
        sentenceList.push({textStartIndex: newStartIndex, textEndIndex: newEndIndex});
        this.sortSentenceList(sentenceList);
    }

    removeSentence = (sentenceList, index) => {
        sentenceList.splice(index, 1);
    }

    updateSentence = (sentenceList, index, newStartIndex, newEndIndex) => {
        const sentence = sentenceList[index];
        const startIndex = sentence.textStartIndex;
        const endIndex = sentence.textEndIndex;

        if (newStartIndex < startIndex) {
            sentence.textStartIndex = newStartIndex;
        }
        if (newEndIndex > endIndex) {
            sentence.textEndIndex = newEndIndex;
        }
    }

    divideSentence = (sentenceList, index, newStartIndex, newEndIndex) => {
        const sentence = sentenceList[index];
        const startIndex = sentence.textStartIndex;
        const endIndex = sentence.textEndIndex;
        if (startIndex === newStartIndex && endIndex > newEndIndex) {
            sentence.textStartIndex = newEndIndex + 1;
        } else if (endIndex === newEndIndex && startIndex < newEndIndex) {
            sentence.textEndIndex = newStartIndex - 1;
        } else {
            sentenceList.splice(index, 1);
            sentenceList.push({textStartIndex: startIndex, textEndIndex: newStartIndex - 1});
            sentenceList.push({textStartIndex: newEndIndex + 1, textEndIndex: endIndex});
        }

        this.sortSentenceList(sentenceList);
    }

    setUpdateContent = () => {
        this.updateContent = JSON.parse(JSON.stringify(this.getSelectedContent()));
    }

    sortSentenceList = (sentenceList) => {
        sentenceList.sort((a,b) => a.textStartIndex - b.textStartIndex);
    }

    saveContent = () => {
        let content = this.getSelectedContent();

        content.sentenceContents = this.updateContent.sentenceContents;
    }


    isChangeContent = () => {
        return JSON.stringify(this.originalContentList) !== JSON.stringify(this.contentList);
    }

    setPopoverState = (boolean) => {
        if (this.popoverState !== null) {
            this.popoverState = boolean;
        }
    }

    * getOddStepFiveContent(step, day, callback) {
        this.commonStore.setLoadingState();
        try {
            console.log(logPrefix, 'Start getOddStepFiveContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/5`;
            const response = yield this.contentRepository.getContent(url);

            this.contentList = response.data;
            for (const content of this.contentList) {
                this.sortSentenceList(content.sentenceContents);
            }
            this.originalContentList = JSON.parse(JSON.stringify(this.contentList));

            console.log(logPrefix, 'Finished getOddStepFiveContent.');
            callback && callback(response.data);
        } catch (e) {
            console.log(logPrefix, 'Failed getOddStepFiveContent.');
            this.openErrorDialog({
                titleText: '컨텐츠 불러오기 오류',
                text: displayErrorDialogPrompt(e, '컨텐츠를 불러오는 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * modifyOddStepFiveContent(step, day, callback) {
        this.commonStore.setLoadingState('데이터를 저장하는 중입니다.');
        try {
            console.log(logPrefix, 'Start modifyOddStepFiveContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/5`;

            const updateContentList = [];
            for (const content of this.contentList) {
                const originalContent = this.originalContentList.find(o => o.listeningContentId === content.listeningContentId);
                if (originalContent) {
                    if (JSON.parse(JSON.stringify(originalContent.sentenceContents)) !== JSON.parse(JSON.stringify(content.sentenceContents))) {
                        updateContentList.push(content);
                    }
                }
            }

            const response = yield this.contentRepository.putContent(url, updateContentList);
            console.log(logPrefix, 'Finished modifyOddStepFiveContent : ', response);
            callback && callback();
        } catch (e) {
            this.commonStore.initLoadingState();
            console.log(logPrefix, 'Failed modifyOddStepFiveContent.');
            this.openErrorDialog({
                titleText: '컨텐츠 수정 오류',
                text: displayErrorDialogPrompt(e, '컨텐츠 수정 작업중 에러가 발생했습니다.')
            });
        }
    }

    isOddStepFiveCompleted = (dataArray) => {
        if (dataArray.length < 4) {
            return false;
        }

        for (const data of dataArray) {
            if (data.sentenceContents.length === 0) {
                return false;
            }
        }

        return true;
    }
}

